import { useEffect, useMemo } from 'react';
import { Node, NodeTypes, ReactFlow, useReactFlow } from 'reactflow';
import 'reactflow/dist/style.css';
import './ReactFlowPaneCSS.css';
import { ParaLeftNodeFlow } from './node-types/ParaLeftNodeFlow';
import { ParaRightNodeFlow } from './node-types/ParaRightNodeFlow';
import { LineNodeFlow } from './node-types/LineNodeFlow';
import { TextNodeFlow } from './node-types/TextNodeFlow';

export const VShapeFlow= ({ width, height, nodes }: {
    width: number;
    height: number;
    nodes: Node<Node[], string | undefined>[]
}) => {
    const { fitView } = useReactFlow();
    const nodeTypes: NodeTypes = useMemo(
        () => ({
            leftWing: ParaLeftNodeFlow,
            rightWing: ParaRightNodeFlow,
            lineNode: LineNodeFlow,
            textNode: TextNodeFlow,
        }),
        []
    );

    useEffect(() => {
        fitView({ maxZoom: 1 });
    }, [width, height]);

    return (
        <ReactFlow
            nodes={nodes}
            nodeTypes={nodeTypes}
            panOnDrag={true}
            onPaneClick={undefined}
            onPaneScroll={undefined}
            zoomOnScroll={true}
            zoomOnPinch={true}
            selectionKeyCode={undefined}
            selectionMode={undefined}
            zoomActivationKeyCode={undefined}
            selectNodesOnDrag={undefined}
            zoomOnDoubleClick={false}
            style={{ backgroundColor: 'var(--mantine-color-body)' }}
            proOptions={{ hideAttribution: true }}
        />
    );
};
